
<div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Activador Akashico<sup>®</sup><span class="theme-color"> II</span></h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Creative People Area -->

<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 class="theme-color">Descripción General del Curso</h3>
                        <h2><span class="secondary-color">Activador Akashico<sup>®</sup> II</span></h2>
                        <p><br>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quo consequuntur blanditiis magni cum ad eaque necessitatibus nulla inventore nesciunt quasi accusantium tempore, expedita temporibus dolore quibusdam dolorum in neque!</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">
                    
                   
                    <div class="tab">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill"
                                    href="#pills-profile" role="tab" aria-controls="pills-profile"
                                    aria-selected="false" style="background: #491d6b; color: white; margin-left: 10px;">
                                    Practicante</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                                    href="#pills-home" role="tab" aria-controls="pills-home"
                                    aria-selected="true">Facilitador</a>
                            </li>
                            
                            <li class="nav-item">
                                <a class="nav-link" id="pills-detalles-tab" data-toggle="pill"
                                    href="#pills-detalles" role="tab" aria-controls="pills-detalles"
                                    aria-selected="false" style="background: #f39302; color: white; margin-left: 10px;">
                                    +</a>
                            </li>
                            
                        </ul>
                        <div class="tab-content" id="pills-tabContent" >
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <p></p>
                                <app-aa2facilitador></app-aa2facilitador>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab" >
                                <app-aa2practicante></app-aa2practicante>
                            </div>
                            <div class="tab-pane fade" id="pills-detalles" role="tabpanel"
                                aria-labelledby="pills-detalles-tab" >
                                <app-extrainfocursos></app-extrainfocursos>
                            </div>
                           
                        </div>
                    </div>
                  
                                   
               
                </div>
            </div>
        </div>
    </div>
</div>

<app-beneficios></app-beneficios>
<app-unete-comunidad></app-unete-comunidad>

